export default __webpack_public_path__ + "static/sunchang-083cb7c7bc465b4dc1d57869ac4ddef6.jpg";